const ADD_SALE = "ADD_SALE";
const DELETE_SALE = "DELETE_SALE";
const SALES = "SALES";
const ADD_SALE_ERROR = "ADD_SALE_ERROR";
const SALE_DETAILS = "SALE_DETAILS";

export { ADD_SALE, DELETE_SALE, SALES, ADD_SALE_ERROR, SALE_DETAILS };
